<template>
  <div>
    <div class="breadcrumb">
      <h1 style="color: #AC8400;">{{ title }}</h1>
    </div>

    <!-- Breadcrumbs -->
    <div style="padding: 10px; background-color: #F2F2F2">
      <router-link to="/dashboard">
        Dashboard
      </router-link>

      <span v-if="breadCrumbs.length > 0">/</span>

      <span v-if="breadCrumbs.length > 0" v-for="(breadCrumb, index) in breadCrumbs" :key="index">
        <span v-if="breadCrumb.path">
          <router-link :to="breadCrumb.path">
            {{ breadCrumb.name }}
          </router-link>
        </span>
        <span v-else>
          <b>
            {{ breadCrumb.name }}
          </b>
        </span>
        <span v-if="index !== breadCrumbs.length - 1">/</span>
      </span>
    </div>

    <div class="separator-breadcrumb border-top"></div>
  </div>
</template>

<script>

export default {
  name: "Header-Breadcrumb",

  props: {
    breadCrumbs: {
      type: Array,
      required: true
    },
    title: {
      type: String,
      required: false,
      default: "Page Title"
    }
  }
}
</script>
